import { Action } from './types'

export const setTabulationLock = (lock: boolean): Action => ({
  type: 'TABULATION_SET_LOCK',
  payload: lock
})



// WEBPACK FOOTER //
// ./src/actions/tabulation.ts